<template>
	<div class="register-page">
		<LoginHeader />
		<div class="body margin-general">
			<instructions
				:hideIntructionsMobile="hideIntructionsMobile"
				type="register"
			/>
			<Form
				class="register-page__form"
				:email="registerEmail"
				:step="registerStep"
				:attempt="registerAttempt"
				@started="started"
				@register="register"
				@onError="onFormError"
				@subStep="onSubStep"
			/>
		</div>

		<div class="footer margin-general">
			<FooterDefault />
		</div>

		<Preloader :showModal="showM" />
	</div>
</template>

<script>
import { Logger } from 'aws-amplify'
import Modal from '@/components/Modal'
import {
	getCurrentInstance,
	onMounted,
	onUnmounted,
	ref,
} from '@vue/runtime-core'
//import FooterLTD from '@/components/cabinet/ltd/FooterLTD.vue'
import FooterDefault from '@/components/cabinet/default/FooterDefault.vue'
import Form from '@/components/login/Form'
import store from '@/store'
import router from '@/router'
import { useRoute } from 'vue-router'
import { getApplicationsByEmail } from '../../plugins/authUtils'
import axios from 'axios'
import Preloader from '@/components/Preloader'
import TVButtonBase from '../../../modules/ui/TVButtonBase.vue'
import { TITLE } from '@/plugins/countries'
import LoginHeader from '@/components/login/LoginHeader'
import { i18n } from '@/plugins/i18n'
import Instructions from '@/components/register/Instructions.vue'
import OTPInput from '../../../src/components/settings_new/atoms/OTPInput.vue'

const logger = new Logger('main')

export default {
	mounted() {
		const pageTitle = 'Register with Tradeview Markets - Start Trading Today'
		const metaContent =
			'Sign up for a Tradeview Markets account and begin your trading journey. Enjoy access to a wide range of markets, innovative platforms, and top-notch services.'

		document.title = pageTitle

		// Meta tags array
		const metaTags = [
			{ name: 'title', content: pageTitle },
			{ name: 'description', content: metaContent },
			{ name: 'twitter:title', content: pageTitle },
			{ name: 'twitter:description', content: metaContent },
			{ property: 'og:title', content: pageTitle },
			{ property: 'og:description', content: metaContent },
		]

		// Set or create meta tags
		metaTags.forEach(({ name, property, content }) => {
			let metaTag = document.querySelector(
				`meta[name="${name}"], meta[property="${property}"]`,
			)
			if (metaTag) {
				metaTag.content = content
			} else {
				metaTag = document.createElement('meta')
				if (name) {
					metaTag.name = name
				}
				if (property) {
					metaTag.property = property
				}
				metaTag.content = content
				document.head.appendChild(metaTag)
			}
		})
	},
	name: 'Register',
	components: {
		LoginHeader,
		Modal,
		Form,
		Preloader,
		FooterDefault,
		OTPInput,
		TVButtonBase,
		Instructions,
	},
	setup() {
		const titleOptions = TITLE
		let title = ref({
			value: null,
			isValid: false,
		})

		let showM = ref(false)
		let dialogMessage = ref(null)
		let dialogMessage2 = ref(null)
		let dialogMessage3 = ref(null)
		let dialogMessage4 = ref(null)
		let dialogErrorMesssage = ref(null)
		let showDialog = ref(false)
		let showCodeDialog = ref(false)
		let newCode = ref(null)
		let user = ref(null)
		let authUser = ref(null)
		let registerStep = ref(1)
		let registerEmail = ref(null)
		let registerAttempt = ref(0)
		let attemptedEmail = ref(null)
		let emailUser = ref(null)
		let hideIntructionsMobile = ref(false)
		let countryActual = ref(null)

		const internalInstance = getCurrentInstance()
		const emitter = internalInstance.appContext.config.globalProperties.emitter

		let currentPassword

		const route = useRoute()

		onMounted(async () => {
			store.commit('setLoginFlow', 'REGISTER')

			countryActual.value = await fetchLocalIP()

			currentPassword = null
			emitter.on('authStateUpdated', (args) => {
				switch (args.state) {
					case 'REGISTERED':
						attemptedEmail.value = args.email
						emitter.emit('showCodeDialog', i18n.global.t('verifiCode.title'))
						emitter.emit('showCodeDialog2', i18n.global.t('verifiCode.text2'))
						break
				}
			})

			emitter.on('closeAllRegisterDialogs', () => {
				showDialog.value = false
				showCodeDialog.value = false
			})

			emitter.on('userSet', () => {
				registerStep.value = 2
				if (store.state.user !== null) {
					registerEmail.value = store.state.user.email
				} else {
					if (localStorage.getItem('typeAccount') === 'live-account') {
						router.replace('/cabinet/console/welcome').catch((error) => {
							logger.error(error)
						})
					} else {
						router.replace('/cabinet/console/NewDemoAccount').catch((error) => {
							logger.error(error)
						})
					}
				}
			})

			localStorage.setItem('typeAccount', route.params.account)

			switch (route.params.id) {
				case '3':
					emitter.emit('requestSignOut')
					break
				case '2':
					registerStep.value = 2
					if (store.state.user !== null) {
						if (
							route.params.account === 'live-account' &&
							route.params.account === 'demo-account'
						) {
							registerEmail.value = store.state.user.email
						}
					}
					break
				case '1':
					if (
						route.params.account !== 'live-account' &&
						route.params.account !== 'demo-account'
					) {
						store.commit('setTypeAccount', route.params.account)
						localStorage
							.setItem('typeAccount', store.state.typeAccount)
							.catch((error) => {
								logger.error(error)
							})
					} else {
						store.commit('setTypeAccount', route.params.account)
					}
					break
				default:
					registerStep.value = 1
					break
			}
		})

		onUnmounted(() => {
			emitter.off('authStateUpdated')
			emitter.off('userSet')
			emitter.off('closeAllRegisterDialogs')
		})

		const started = async (email, password, disclaimer) => {
			currentPassword = password
			emailUser.value = email
			emitter.emit('requestSignUp', {
				email: email,
				password: password,
				disclaimer: disclaimer,
			})
		}

		const register = (
			email,
			firstName,
			lastName,
			accountType,
			disclaimer,
			country,
			entity,
			checkRegistration,
		) => {
			let additionalParams = {}

			if (accountType === 'JOINT') {
				additionalParams.account_role = 'primary'
			}

			showM.value = true
			disclaimer = true
			if (store.state.user !== null) {
				let applicationProcess
				createApplicationProcess(
					store.state.user.email,
					accountType,
					disclaimer,
					additionalParams, // Pasar los parámetros adicionales aquí
				)
					.then((appProcess) => {
						applicationProcess = appProcess
						return registerUserInitialStepV2(
							store.state.user.email,
							accountType,
							firstName,
							lastName,
							applicationProcess.id,
							disclaimer,
							country,
							entity,
							checkRegistration,
							additionalParams, // Pasar los parámetros adicionales aquí
						)
					})
					.then((result) => {
						store.commit('setApplication', applicationProcess)
						emitter.emit('applicationUpdated')
						emitter.emit('doAuthenticatedUser', store.state.user.email)
						showM.value = false
					})
					.catch((error) => {
						console.error('Error en la función register:', error)
						logger.error(error)
					})
			} else {
				console.error('Error en la función register: userInfo is null')
				logger.error('userInfo is null')
			}
		}

		const createApplicationProcess = (
			email,
			accountType,
			disclaimer,
			additionalParams = {},
		) => {
			return new Promise((resolve, reject) => {
				showM.value = true
				let _url =
					process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
					'/create/setup-account'

				let _headers = {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					Authorization: 'Bearer ' + store.state.token,
				}
				let _data = {
					applicationType:
						accountType === null || accountType === undefined
							? 'INDIVIDUAL'
							: accountType,
					disclaimer: disclaimer,
					...additionalParams, // Fusionar los parámetros adicionales aquí
				}

				axios({ method: 'POST', url: _url, data: _data, headers: _headers })
					.then((result) => {
						let application = result.data
						if (application !== null) {
							showM.value = false
							resolve(application)
						} else {
							console.error(
								'Error en createApplicationProcess: unable to update the application record',
							)
							logger.error('ERROR: unable to update the application record')
							reject('ERROR: unable to update the application record')
						}
					})
					.catch((error) => {
						console.error('Error en createApplicationProcess:', error)
						logger.error(error)
						reject(error)
					})
			})
		}

		const registerUserInitialStepV2 = (
			email,
			accountType,
			firstName,
			lastName,
			appID,
			disclaimer,
			country,
			entity,
			checkRegistration,
			additionalParams = {},
		) => {
			return new Promise((resolve, reject) => {
				showM.value = true

				let _url =
					process.env.VUE_APP_CABINET_V2_API_HOST_USER + '/user/initial'
				let _headers = {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					Authorization: 'Bearer ' + store.state.token,
				}
				let _data = {
					email,
					firstName: firstName,
					lastName: lastName,
					accountType:
						accountType === null || accountType === undefined
							? 'INDIVIDUAL'
							: accountType,
					applicationID: appID,
					disclaimer: disclaimer,
					country:
						country === null || country === undefined
							? countryActual.value
							: country,
					entity: entity,
					checkRegistration:
						checkRegistration === null || checkRegistration === undefined
							? true
							: checkRegistration,
					...additionalParams, // Fusionar los parámetros adicionales aquí
				}

				if (entity === null) {
					delete _data.entity
				}

				axios({ method: 'POST', url: _url, data: _data, headers: _headers })
					.then((result) => {
						let data = result.data
						let user = data.user
						store.commit('updateUser', user)
						resolve(user)
						showM.value = false
					})
					.catch((error) => {
						console.error('Error en registerUserInitialStepV2:', error)
						logger.error(error)
						reject(error)
					})
			})
		}

		const onFormError = async (title, body) => {
			emitter.emit('showDialog', body)
		}

		const onSubStep = async (val) => {
			hideIntructionsMobile.value = val === 2 ? true : false
		}

		const handleOtpEntered = (code) => {
			newCode.value = code.trim()
		}

		const fetchLocalIP = async () => {
			try {
				const response = await fetch('https://dcsz5gywka2h4.cloudfront.net/')
				if (!response.ok) {
					throw new Error('Network response was not ok')
				}
				const text = await response.text()
				return text
			} catch (error) {
				console.error('Error fetching data:', error)
				return undefined
			}
		}

		const submitNewCode = async () => {
			if (currentPassword !== null) {
				emitter.emit('requestConfirmSignUpAndLogin', {
					email: attemptedEmail.value,
					newCode: newCode.value,
					password: currentPassword,
				})
			} else {
				emitter.emit('requestConfirmSignUp', {
					email: attemptedEmail.value,
					newCode: newCode.value,
				})
			}
		}

		return {
			started,
			register,
			onFormError,
			handleOtpEntered,
			submitNewCode,
			dialogMessage,
			dialogMessage2,
			dialogMessage3,
			dialogMessage4,
			dialogErrorMesssage,
			showDialog,
			showCodeDialog,
			newCode,
			user,
			authUser,
			registerStep,
			registerEmail,
			registerAttempt,
			attemptedEmail,
			showM,
			title,
			titleOptions,
			emailUser,
			onSubStep,
			hideIntructionsMobile,
			fetchLocalIP,
			countryActual,
		}
	},
}
</script>

<style scoped lang="scss">
.test-selector {
	max-width: 300px;
	position: absolute;
	top: 800px;
	left: 100px;
}

.modal-body p {
	text-align: left;
}

.register-page__footer .register-footer.mobile {
	width: 100% !important;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
